module.exports = __webpack_public_path__ + "static/media/summary.bdcaae41.svg";